<template>
  <div class="">
    <app-download
      :data="items"
      :fields="fields"
      :labels="labels"
      encoding="utf-8"
      name="applications.csv"
    >
      <b-button variant="success">{{ $t('export.search-results.csv') }}</b-button>
    </app-download>
  </div>
</template>
<script>
import jsonCSV from "vue-json-csv";
export default {
  props: ["items"],
  data() {
    return {
      fields: [
        "id",
        "created",
        "name",
        "community_name",
        "supporting_org_type",
        "supporting_org",
        "supporting_org_2",
        "supporting_org_3",
        "application_stage",
        "approval_date",
        "status",
        "province",
        "territory",
        "sector",
        "entity_name",
        "group",
        "request_approval_entity",
        "area",
        "smp_approved",
        "smp_approval_date",
        "smp_entered_date",
        "potential_mode",
        "community_org_type",
        "management_plan_approval",
        "management_stage_updated",
        "operating_mode",
      ],
      labels: {
        id: "id",
        created: this.$i18n.t('export.fields.created'),
        name: this.$i18n.t('export.fields.name'),
        community_name: this.$i18n.t('export.fields.community-name'),
        supporting_org_type: this.$i18n.t('export.fields.supporting-org-type'),
        supporting_org: this.$i18n.t('export.fields.supporting-org'),
        supporting_org_2: this.$i18n.t('export.fields.supporting-org-2'),
        supporting_org_3: this.$i18n.t('export.fields.supporting-org-3'),
        application_stage: this.$i18n.t('export.fields.application-stage'),
        approval_date: this.$i18n.t('export.fields.approval-date'),
        status: this.$i18n.t('export.fields.status'),
        province: this.$i18n.t('export.fields.province'),
        territory: this.$i18n.t('export.fields.territory'),
        sector: this.$i18n.t('export.fields.sector'),
        entity_name: this.$i18n.t('export.fields.entity-name'),
        group: this.$i18n.t('export.fields.group'),
        request_approval_entity: this.$i18n.t('export.fields.request-approval-entity'),
        area: this.$i18n.t('export.fields.area'),
        smp_approved: this.$i18n.t('export.fields.smp_approved'),
        smp_approval_date: this.$i18n.t('export.fields.smp_approval_date'),
        management_stage_updated: this.$i18n.t('export.fields.management_stage_updated'),
        smp_entered_date: this.$i18n.t('export.fields.smp_entered_date'),
        potential_mode: this.$i18n.t('export.fields.potential_mode'),
        community_org_type: this.$i18n.t('export.fields.community_org_type'),
        management_plan_approval: this.$i18n.t('export.fields.management_plan_approval'),
        operating_mode: this.$i18n.t('export.fields.operating_mode')
      }
    };
  },
  components: {
    appDownload: jsonCSV
  }
};
</script>
<style scoped>
</style>
